import { render } from "./User-list.vue?vue&type=template&id=6dca61bf&scoped=true"
import script from "./User-list.vue?vue&type=script&lang=js"
export * from "./User-list.vue?vue&type=script&lang=js"

import "./User-list.vue?vue&type=style&index=0&id=6dca61bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dca61bf"]])

export default __exports__